import { DropzoneStyles } from '@fountain/fountain-ui-components';
import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>
  createStyles({
    uploadWrapper: {
      display: 'flex',
      flexDirection: 'column',
      '& .dzu-inputLabel': {
        width: '100%',
      },
    },
    uploadInputContainer: {
      height: '160px',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      border: `1px dashed ${theme.palette.common.gray300}`,
      padding: theme.spacing(2),

      '& span[role="button"]': {
        margin: `${theme.spacing(4)}px auto ${theme.spacing(2)}px`,
      },

      [theme.breakpoints.down('xs')]: {
        '& p:first-of-type': {
          display: 'none',
        },
      },
    },
    fileSize: {
      color: theme.palette.common.gray600,
    },
    active: {
      backgroundColor: theme.palette.common.gray300,
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      border: `1px dashed ${theme.palette.common.gray300}`,
      '& p': {
        marginTop: theme.spacing(2),
      },
    },
    circularProgress: {
      position: 'relative',
    },
    actionContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      gap: theme.spacing(2),
    },
    actionButton: {
      width: 108,
      borderRadius: '5px',
    },
    previewWrapper: {
      textAlign: 'left',
    },
    previewName: {
      margin: theme.spacing(1, 0),
      overflowWrap: 'anywhere',
    },
    previewSize: {
      color: theme.palette.common.gray600,
    },
    imagePreview: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.palette.common.gray100,

      '& img': {
        maxHeight: '100%',
        maxWidth: '100%',
      },
    },
    previewButton: {
      padding: theme.spacing(2),
      textAlign: 'left',
    },
    iconDark: {
      filter: 'brightness(0)',
    },
    error: {
      color: theme.palette.common.red400,
    },
  }),
);

export const dropzoneStyles = {
  dropzone: {
    border: 'none',
    width: '100%',
    textAlign: 'center',
  },
  inputLabel: {
    position: 'relative',
    flex: 1,
    display: 'flex',
  },
  input: {
    position: 'absolute',
    top: 0,
    height: '100%',
    width: '100%',
    opacity: 0,
    cursor: 'pointer',
  },
  inputLabelWithFiles: {
    display: 'none',
  },
  preview: {
    display: 'none',
  },
} as DropzoneStyles;
